import { useEffect, type ReactNode } from 'react';
import { setActiveProject } from '@/lib/project-context/project-context-bindings';
import { setSelectedProject } from '../model/selected-project.store';
import type { ProjectDetail } from '../model/types';

interface SelectedProjectProviderProps {
  project: ProjectDetail;
  children: ReactNode;
}

export function SelectedProjectProvider({ project, children }: SelectedProjectProviderProps) {
  useEffect(() => {
    setSelectedProject(project);
    setActiveProject({ id: project.id, platformProjectId: project.platformProjectId || null });

    return () => {
      setSelectedProject(null);
      setActiveProject(null);
    };
  }, [project]);

  return <>{children}</>;
}
